import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import logoImage from "../images/logo.png";
import { LANDING_URL } from "./constants";
import { trackEvent } from "../helpers/trackEvent";
import { useAuth } from "../auth/AuthContext";

const getAppUrlWithoutDemo = () => "/events";

const Header = ({
  isDemoMode = false,
  backTo = null,
  backLabel = "Back",
  onBackClick = null,
  title = "",
}) => {
  const { signOut, user } = useAuth();
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const accountMenuRef = useRef(null);

  useEffect(() => {
    if (!isAccountMenuOpen) return undefined;

    const handleDocumentClick = (event) => {
      if (!accountMenuRef.current?.contains(event.target)) {
        setIsAccountMenuOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsAccountMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isAccountMenuOpen]);

  const handleSignOut = async () => {
    setIsAccountMenuOpen(false);
    await signOut();
  };

  return (
    <header className="header">
      <div className="logo-section">
        {backTo && (
          <Link
            aria-label={backLabel}
            className="button header-back-button"
            onClick={onBackClick || undefined}
            title={backLabel}
            to={backTo}
          >
            <ArrowBackIcon fontSize="small" />
          </Link>
        )}
        <a href={LANDING_URL} target="_blank" rel="noreferrer">
          <img
            src={logoImage}
            alt="BadgeFlow logo"
            className="badgeflow-logo"
          />
        </a>
        {isDemoMode && (
          <span className="header-demo-label">Demo</span>
        )}
      </div>

      <div className="header-center-title" title={title || undefined}>
        {title}
      </div>

      <div className="header-right">
        {isDemoMode ? (
          <a
            className="primary"
            href={getAppUrlWithoutDemo()}
            target="_blank"
            onClick={() => {
              trackEvent({
                action: "header_create_badges_now_clicked",
              });
            }}
          >
            Create your badges now
          </a>
        ) : (
          <div className="header-account" ref={accountMenuRef}>
            <button
              aria-expanded={isAccountMenuOpen}
              aria-haspopup="menu"
              className="header-account-trigger"
              onClick={() => setIsAccountMenuOpen((isOpen) => !isOpen)}
              type="button"
            >
              <span className="header-user" title={user?.email}>{user?.email}</span>
              <AccountCircleOutlinedIcon fontSize="small" />
            </button>
            {isAccountMenuOpen && (
              <div className="header-account-menu" role="menu">
                <button
                  className="header-account-menu-item"
                  onClick={handleSignOut}
                  role="menuitem"
                  type="button"
                >
                  <LogoutOutlinedIcon fontSize="small" />
                  Sign out
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
